function applyClasses() {
    Object.entries(resProductIds).forEach(([productId, value]) => {
        const productElement = document.querySelector(`[data-product-id="${productId}"]`);
        if (productElement) {
            const className = value ? 'hide-quick-add-or-atc-xx' : 'hide-build-your-kit-btn-xx';
            productElement.classList.add(className);
        }
    });
}

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
            const productList = document.querySelector('.boost-sd__product-item');
            if (productList) {
                applyClasses();
                // observer.disconnect();
            }
        }
    });
});

const targetSection = document.querySelector('.app-wrapper-extended');
if (targetSection) {
    observer.observe(targetSection, { childList: true, subtree: true });
}
   